import Vue from 'vue';
import axios from 'axios';
import '@/filters';
import { WebCam } from 'vue-web-cam';
import { DxTagBox } from 'devextreme-vue';
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxColumnFixing
} from 'devextreme-vue/data-grid';
import readings from '../../applications/appDetails/readings/readings';

Vue.component(WebCam.name, WebCam);

const readingStatusDef = {
  None: { name: 'None', type: 0 },
  Unread: { name: 'Unread', type: 1 },
  Read: { name: 'Read', type: 2 },
  Completed: { name: 'Completed', type: 3 }
};

export default {
  name: 'CaptureMeterReadingsControlPanel',
  components: {
    DxTagBox,
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxColumnFixing,
    SearchBar: require("@/components/searchBarWithSearchOptions/searchBarWithSearchOptions.vue").default,
    BillingGroups: require("@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBillingGroups/cmrControlPanelBillingGroups.vue").default,
    BookWalks: require("@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBooksWalks/cmrControlPanelBooksWalks.vue").default,
    EditReading: require("@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelEditReading/cmrControlPanelEditReading.vue").default,
    Readings: require("@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelReadings/cmrControlPanelReadings.vue").default,
  },
  data: function () {
    return {
      bSpotBillEnabled: false,
      bIsFieldWorker: true,
      isPropertyOriented: false,
      editingOptions: [],
      descrepancyNoAccess: [],
      noAccess: {},
      descrepancyMrNote: [],
      mrNote: {},
      consumerType: [],
      meterMake: [],
      meterSize: [],
      meterLocations: [],
      bHasPhone: false,
      userName: '',
      active: 'first',
      a_first: false,
      a_second: false,
      a_third: false,
      a_fourth: false,
      billingGroup: '',
      billingGroupId: -1,
      billGroupselected: false,
      booksWalk: { bookId: null, walkId: null, name: null, billingGroupId: null, cycleId: -1 },
      editingReading: {},
      readingsOptions: { pageSize: 10, total: 0, page: 1, filterText: this.search },
      readings: [],
      readingsTrimed: [],
      readingsPagination: [],
      gridOptions: { bAutoExpand: true, bPagination: true, bGroupPanel: false, bColumnReordering: false, bColumnFixing: false, },
      trim: { read: false, unread: false, spotBill: false, withNote: false, withAccess: false, disconnected: false, discrepancy: false, },
      statuses: [ readingStatusDef.None, readingStatusDef.Unread, readingStatusDef.Read, readingStatusDef.Completed ],
      totalRowReading: 0,
      filterBuilderPopupPosition: { of: window, at: 'top', my: 'top', offset: { y: 10 } },
      editButtons: [{ hint: 'Edit', icon: 'edit', visible: true, onClick: this.editReading },],
      searchType: 1,
      searchQuery: '',
      searchItem: null,
      billingGroupsDataObj: {
        selected: this.onSelectBillGroup,
        navigateFunc: this.navigate
      },
      booksWalksDataObj: {
        selected: this.onSelectBooksWalk,
        navigateFunc: this.navigate,
        billingGroup: { id: null, name: null, cycleId: null }
      },
      readingsDataObj: {
        selected: this.onSelectReading,
        navigateFunc: this.navigate,
        booksWalks: { bookId: null, walkId: null, name: null, billingGroupId: null },
        descrepancyNoAccess: [],
        descrepancyMrNote: [],
        isDisconnectedColor: this.isDisconnectedColor,
        isDisconnectedDiscrepancyColor: this.isDisconnectedDiscrepancyColor,
        cycleId: -1,
        consumerType: [],
        editingOptions: [],
        meterMake: [],
        meterSize: [],
        meterLocations: [],
        editingReading: this.editingReading,
        isPropertyOriented: false,
        readings: [],
      },
    }
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadingsAdmin != true)
      this.$router.push('/employeeHome');

    this.getSettings();
    this.getCommonData();
    this.getProfileDetails();
    //==============================================================================================
    //==============================================================================================
    //For Automation - To Be Removed
    //this.billingGroup = { "id": "003", "name": "[003] Nelspruit 03", "cycleId": 3324 };
    //this.onSelectBooksWalk({"bookId":"N003","walkId":1,"name":"[N003] Walk: 1","billingGroupId":"003","cycleId":3324});
    //setTimeout(() => {
    //  this.onSelectBooksWalk({ "bookId": "N003", "walkId": 1, "name": "[N003] Walk: 1", "billingGroupId": "003" });
    //  //this.onSelectReading({
    //  //  "selectedReading": { "connectionId": 9277, "connectionStatus": "1", "bookId": "N003", "walkId": 1, "sequence": 5, "readingDiscrepancyType": 0, "readingDiscrepancy": "Accepted", "rejected": false, "status": 2, "isReadOnly": false, "meterReaderName": "Mr Sibusiso MYANGA", "tenantName": "TSOGO SUN HOLDINGS (PTY) LTD   M", "propertyAddress": "GOVERNMENT BOULEVARD 1 MB0006", "serialNo": "SEN0120705709", "account": "91540342", "meterId": 111573, "meterRef": "SEN0120705709", "meterMakeId": "02", "meterSizeId": "07", "noDials": 7, "propRef": "21/1/4/0/0/0", "connNo": 1, "crReading": 3333, "crDate": "[native Date Tue Jan 17 2023 00:00:00 GMT+0200 (Eastern European Standard Time)]", "crTime": "000000", "clockOver": false, "convFactor": 1, "accessCodeId": 0, "mrMsgCodeId": 0, "comment": "NEW METER AVERAGE OF 288KL USED", "meterTagNo": null, "cellTelNo": null, "consumerTypeId": "02", "consumerType": "Business", "connType": 0, "bulkConnectionId": 0, "bulkConnectionConnNo": 0, "statementNo": null, "diffFromMainConsumption": 0, "connectionGpsX": 30.96805499, "connectionGpsY": -25.43972666, "connectionCoordX": -3213279.63034665, "connectionCoordY": -2814765793.058602, "prAvrCns": 8.219, "isPosted": false, "consumptionModified": false, "dialsModified": false, "isNewConnection": false, "actionRequestPosted": false, "prDate1": "[native Date Sat Dec 17 2022 00:00:00 GMT+0200 (Eastern European Standard Time)]", "prRead1": 3015, "prCons1": 417, "prReadCmnt1": null, "prReadNoAccess1": "None", "prReadMrNote1": "None", "rdgType1": 0, "prDate2": "2022-11-21T00:00:00", "prRead2": 2598, "prCons2": 387, "prReadCmnt2": "FROM METERMAN", "prReadNoAccess2": "None", "prReadMrNote2": "None", "rdgType2": 0, "prDate3": "2022-10-19T00:00:00", "prRead3": 2211, "prCons3": 243, "prReadCmnt3": "READING TAKEN FROM METERMAN", "prReadNoAccess3": "None", "prReadMrNote3": "None", "rdgType3": 0, "prDate4": "2022-09-19T00:00:00", "prRead4": 1968, "prCons4": 263, "prReadCmnt4": "READING 1968 TAKEN FROM METERMAN", "prReadNoAccess4": "None", "prReadMrNote4": "None", "rdgType4": 0, "previousDates": ["2022-12-17T00:00:00", "2022-11-21T00:00:00", "2022-10-19T00:00:00", "2022-09-19T00:00:00"], "previousReadings": [3015, 2598, 2211, 1968], "previousConsumptions": [417, 387, 243, 263], "previousComments": [null, "FROM METERMAN", "READING TAKEN FROM METERMAN", "READING 1968 TAKEN FROM METERMAN"], "previousNoAccess": ["None", "None", "None", "None"], "previousMrNotes": ["None", "None", "None", "None"], "previousReadingType": [0, 0, 0, 0], "similarPeriodConsumptionMin": 197, "similarPeriodConsumptionMax": 328, "bulkSubConnectionsConsumption": null, "bulkAverageConsumptionDiffMin": null, "bulkAverageConsumptionDiffMax": null, "numbering": 0, "fullId": "N003-1-5", "statusText": "Read", "changeOfAverageCons": NaN, "name": 0, "accessDisplay": "None", "noteDisplay": "None", "consumption": 318, "curAvrCns": 9.9375, "curAvrCnsDisplay": 9.9375, "prAvrCnsDisplay": 8.219, "originalRejectedState": false, "gpsStatus": true },
    //  //  "editingHistory": [{ "sequence": 5, "date": "2022-12-17T00:00:00", "period": "1/2023", "reading": 3015, "consumption": 417, "isBulkMeter": false, "diffFromMainConsumption": 0, "bulkMeterConsumptionDiff": 0, "noAccess": "None", "mrNote": "None", "readingType": 0, "comment": null, "id": 0, "type": 0 }, { "sequence": 5, "date": "2022-11-21T00:00:00", "period": "12/2022", "reading": 2598, "consumption": 387, "isBulkMeter": false, "diffFromMainConsumption": 0, "bulkMeterConsumptionDiff": 0, "noAccess": "None", "mrNote": "None", "readingType": 0, "comment": "FROM METERMAN", "id": 1, "type": 0 }, { "sequence": 5, "date": "2022-10-19T00:00:00", "period": "11/2022", "reading": 2211, "consumption": 243, "isBulkMeter": false, "diffFromMainConsumption": 0, "bulkMeterConsumptionDiff": 0, "noAccess": "None", "mrNote": "None", "readingType": 0, "comment": "READING TAKEN FROM METERMAN", "id": 2, "type": 0 }, { "sequence": 5, "date": "2022-09-19T00:00:00", "period": "10/2022", "reading": 1968, "consumption": 263, "isBulkMeter": false, "diffFromMainConsumption": 0, "bulkMeterConsumptionDiff": 0, "noAccess": "None", "mrNote": "None", "readingType": 0, "comment": "READING 1968 TAKEN FROM METERMAN", "id": 3, "type": 0 }]
    //  //});
    //}, 2000);
    //==============================================================================================
    //==============================================================================================
  },
  methods: {
    async getSettings() {
      let settings = await this.$store.dispatch('getUtilitySettings');
      this.bSpotBillEnabled = settings.spotBilling;
      this.isPropertyOriented = settings.isPropertyOriented;
      this.readingsDataObj.isPropertyOriented = this.isPropertyOriented;
    },
    getCommonData() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CaptureMeterReading/GetCommonData')
        .then(response => {
          this.editingOptions = response.data.editingOptions;
          this.descrepancyNoAccess = response.data.descrepancyNoAccess;
          this.descrepancyMrNote = response.data.descrepancyMrNote;
          this.meterMake = response.data.meterMake;
          this.meterSize = response.data.meterSize;
          this.meterLocations = response.data.meterLocation;
          this.consumerType = response.data.consumerType;

          this.readingsDataObj.descrepancyNoAccess = this.descrepancyNoAccess;
          this.readingsDataObj.descrepancyMrNote = this.descrepancyMrNote;
          this.readingsDataObj.editingOptions = this.editingOptions;
          this.readingsDataObj.meterMake = this.meterMake;
          this.readingsDataObj.meterSize = this.meterSize;
          this.readingsDataObj.consumerType = this.consumerType;
          this.readingsDataObj.meterLocations = this.meterLocations;
          this.readingsDataObj.consumerType = this.consumerType;

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getProfileDetails() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bHasPhone = response.data.item.hasPhone;
            this.bIsFieldWorker = response.data.item.isFieldWorker;
            this.userName = response.data.item.name;
          }
        })
        .catch(e => {
          this.$parent.user.authenticated = false;
          this.$router.push('/login');
        })
    },

    //Record Selection Methods
    onSelectBillGroup(item) {
      if (!item)
        return;

      this.billGroupselected = true;
      this.billingGroup = item;
      this.billingGroupId = item.id;
      this.booksWalksDataObj.billingGroup = this.billingGroup;
      this.$root.$emit('billing_group_selected');
      this.navigate();
    },
    onSelectBooksWalk(item) {
      if (item == null)
        return;

      this.booksWalk = item;
      this.booksWalk.cycleId = this.billingGroup.cycleId;
      this.readingsDataObj.booksWalks = item;
      this.$root.$emit('books_walks_selected', item);
      this.navigate();
    },
    onSelectReading(item, readings) {
      //console.log(item)
      if (item == {} || item.selectedReading.sequence == null)
        return;

      this.editingReading = item.selectedReading;
      this.readingsDataObj.editingReading = this.editingReading;
      this.readingsDataObj.history = item.editingHistory;
      this.readingsDataObj.readings = readings;

      this.$root.$emit('editing_reading_selected');
      this.navigate(4);
    },

    editingReadingChange(item) {
      this.editingReading = item;
    },
    //==============================================
    // Navigation
    navigate(steps = 1) {
      if (isNaN(steps))
        steps = 1;

      let step = this.stepToNum() + steps;

      if (step < 1)
        step = 1;

      if (step > 4)
        step = 4;

      switch (step) {
        default:
        case 1:
          this.active = 'first';
          this.a_first = false;
          this.a_second = false;
          this.a_third = false;
          this.a_fourth = false;
          break;
        case 2:
          this.active = 'second';
          this.a_first = true;
          this.a_second = false;
          this.a_third = false;
          this.a_fourth = false;
          break;
        case 3:
          this.active = 'third';
          this.a_first = true;
          this.a_second = true;
          this.a_third = false;
          this.a_fourth = false;
          break;
        case 4:
          this.active = 'fourth';
          this.a_first = true;
          this.a_second = true;
          this.a_third = true;
          this.a_fourth = false;
          break;
      }
    },
    stepToNum(step = this.active) {
      switch (step) {
        default:
        case 'first': return 1;
        case 'second': return 2;
        case 'third': return 3;
        case 'fourth': return 4;
      }
    },
    //==============================================

    isDisconnectedDiscrepancyColor(item) {
      if (item.connectionStatus == 2 || item.connectionStatus == 3)
        return 'color: red!important;'
      else if (item.readingDiscrepancyType >= 3 && item.readingDiscrepancyType <= 17)
        return 'color: #FF8C00!important;'
      else
        return '';
    },
    isDisconnectedColor(item) {
      if (item.connectionStatus == 2 || item.connectionStatus == 3)
        return 'color: red!important;'
    },

  },
}
